import { Fab, Typography } from '@mui/material';
import Iconify from "../../../components/minimal/iconify/index.jsx";

let text = `
הי דן
הגעתי דרך האתר
אשמח לקבל פרטים נוספים על נימי`;
text = encodeURIComponent(text);
const isMobile = window.innerWidth < 600;

const WhatsappUs = () => {
    return (<a href={`https://wa.me/972583304371?text=${text}`} target="_blank" rel="noreferrer">
        <Fab sx={{
            position: 'fixed',
            bottom: isMobile ? '13px' : '26px',
            left: isMobile ? '13px' : '26px',
            backgroundColor: "#00c217",
            transition: "all .5s",
            borderRadius: "40px",
            display: "flex",
            padding: "8px",
            justifyContent: "space-between",
            overflow: "hidden",
            '&:hover': {
                backgroundColor: "#00a914",
                width: "210px",
            },
            '& .MuiTypography-subtitle2': {
                transition: "all .5s",
                opacity: 0,
                overflow: "hidden",
                display: "inline-block",
                // keep the text on one line
                whiteSpace: "nowrap",
                width: "0px",
            },
            '&:hover .MuiTypography-subtitle2': {
                opacity: 1,
                overflow: "visible",
                width: "145px",
            },
            color: "white"
        }} aria-label="whatsapp" size={isMobile ? 'medium' : 'large'} >
            <Iconify icon="mdi:whatsapp" width={isMobile ? 35 : 40} />
            <Typography variant="subtitle2">
                דברו איתנו ב WhatsApp
            </Typography>
        </Fab>
    </a>);
}

export default WhatsappUs;